<ziro-loading-block [hidden]="!isGeneratingPhone()"></ziro-loading-block>

<div [hidden]="!isInitialized || isGeneratingPhone() || !fieldConfig" data-automation="phone-fields">
  <ziro-text [fieldId]="'name'"></ziro-text>
  <ziro-text [fieldId]="'description'"></ziro-text>
  @for (fieldId of genericSelectFieldIds; track fieldId) {
    <ziro-select [fieldId]="fieldId"></ziro-select>
  }
  @for (fieldId of genericTextFieldIds; track fieldId) {
    <ziro-text [fieldId]="fieldId"></ziro-text>
  }

  @for (field of modelProtocolSpecificSelectFields; track field) {
    <ziro-select [fieldId]="field.fieldId" [hidden]="!field.supported"></ziro-select>
  }
  @for (field of modelProtocolSpecificCheckboxFields; track field) {
    <ziro-checkbox [fieldId]="field.fieldId" [hidden]="!field.supported"></ziro-checkbox>
  }
  @for (fieldId of associatedUserFieldIds; track fieldId) {
    <ziro-select [fieldId]="fieldId"></ziro-select>
  }

  <ng-content></ng-content>
</div>
